import { render, staticRenderFns } from "./MoreDetail.vue?vue&type=template&id=ec4fbaf8&scoped=true"
import script from "./MoreDetail.vue?vue&type=script&lang=ts"
export * from "./MoreDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec4fbaf8",
  null
  
)

export default component.exports